import { render, staticRenderFns } from "./hot_product.vue?vue&type=template&id=47a57a15&scoped=true"
import script from "./hot_product.vue?vue&type=script&lang=js"
export * from "./hot_product.vue?vue&type=script&lang=js"
import style0 from "./hot_product.vue?vue&type=style&index=0&id=47a57a15&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a57a15",
  null
  
)

export default component.exports